import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ProductCommissionModalComponent } from './product-commission-modal.component';

import { ProgressLoaderModule } from '../../general/progress-loader/progress-loader.module';
import { MatExpansionModule } from '@angular/material';
@NgModule({
  declarations: [
    ProductCommissionModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,

    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,

    MatExpansionModule,

    ProgressLoaderModule,
  ],
  exports: [
    ProductCommissionModalComponent
  ],
  entryComponents: [
    ProductCommissionModalComponent
  ]
})
export class ProductCommissionModalModule {
}
